import * as React from 'react';
import { FilterCommonProps, FilterCommonValues } from '../types';
import { ValidationFilter } from './types';

type WrappedComponentType = React.ComponentClass<FilterCommonProps<string>>;

export const withFilterValidation = (validate: ValidationFilter) => (WrappedComponent: WrappedComponentType): WrappedComponentType => {
  return class FilterValidation extends React.Component<FilterCommonProps<string>> {

    private onChange = (id: string, values: FilterCommonValues<string>[]): void => {
      const { translation, onFilterValidationChange, onChange } = this.props;

      const validation = validate(values, translation);
      onFilterValidationChange({ id, validation });

      onChange(id, values);
    };

    public render() {
      const { id, filterValidation } = this.props;

      const validationResult = filterValidation && filterValidation.find(validation => validation.id === id);

      return <WrappedComponent
        {...this.props}
        onChange={this.onChange}
        id={id}
        validation={validationResult && validationResult.validation}
      />;
    }
  };
};
